import { createSlice } from "@reduxjs/toolkit";
import { StoreState } from "../../store/store.interface";
import { GlobalMessageState, Message, MessageType } from "./global-message.interface";

/* For usage instructions, see the src/components/error-message-global.ts file */

/*----- DECLARE INTERFACES ------*/

export const CART_MESSAGE_ID = 'cart';
export const PAYMENT_MESSAGE_ID = 'payment';
export const SAMPLE_MESSAGE_ID = 'sample';
/*----- CREATE INITIAL STATE ------*/

export const globalMessageStateInitialState: GlobalMessageState = {
  messages: {}
};

export const emptyMessage: Message = {
  message: '',
  type: MessageType.none
}

/*----- CREATE STORE SLICE ------*/

export const globalMessageSlice = createSlice({
  name: 'globalMessage',
  initialState: globalMessageStateInitialState,
  reducers: {
    updateGlobalMessage(state, action){
      state.messages = state.messages || {};
      const message: Message =  {
        message: action.payload.message,
        type: action.payload.type || MessageType.primary,
      };
      state.messages[action.payload.id] = message;
    },
    clearGlobalMessages(state){
      state.messages = {};
    }
  },
});

/*----- CREATE SLICE ACTIONS ------*/

export const { updateGlobalMessage, clearGlobalMessages } = globalMessageSlice.actions;

/*----- CREATE SELECTORS ------*/

export const selectGlobalMessage = (state: StoreState, id: string): Message => state.globalMessageState?.messages?.[id] || emptyMessage;

/*----- CREATE REDUCER ------*/

export const globalMessageReducer = globalMessageSlice.reducer;
